module.exports = __webpack_public_path__ + "static/chilli-124db3daa5c4d25cd6ca1917959c02db.png";